import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { utilsFunction,formatFunctions } from '@/helpers/functions'
import { getSafe } from '@/helpers/global';
import { getAccountBalanceAction, getPortfolioAction } from '@/actions/trading'
import { PARAMS as requestParams } from '@/constants/params';
import { ACCOUNT_TYPE } from '@/constants/auth';
import { Converter } from '@/helpers/functions';
import { SERVICES_RESP, Icons } from '@/configurations';
import { colorBindingTypes as colorTypes } from '@/constants/color-binding-type';
import { dataType } from '@/constants/data-type';

class CashAccountProfile extends React.Component {
  constructor(props) {
    super(props)
    props.innerRef(this)
    this.state = {
      asset: {},
      portfolio: {},
      TTLLeftAsset: [
		{ label: 'current_account_buying_power', value: '-' },
        { label: 'current_account_market_value', value: '-' },
        { label: 'current_account_hold_amount', value: '-' },
        { label: 'current_account_margin_Value', value: '-' },
      ],
      TTLRightAsset: [
	    { label: 'current_account_withdrawable_balance', value: '-' },
        { label: 'current_account_pending_balance', value: '-' },
        { label: 'current_account_settled_balance', value: '-' },
        { label: 'current_account_ledger_balance', value: '-' },
      ],
      isLoading: false
    }
  }

  render() {
    const { language, currentTradingAccount, accessibility} = this.props
    const { asset, portfolio, TTLLeftAsset, TTLRightAsset, isLoading } = this.state
    return (
      <div style={{ flex: 1 }} className={classnames("section", "cash-account-profile", "overflow")}>
        <div className="actions-item">
          <b>{getSafe(() => language.current_account)} - {getSafe(() => currentTradingAccount.tradingAccountID, '----')} ({getSafe(() => this.accountType(currentTradingAccount.accountType), '--')})</b>
          <div>
            {isLoading && <Icons.Loading />}
            {/* <img onClick={this.getAccountBalance}
              className="pointer img-icon-12" src={RefreshIcon} alt='refresh_icon' /> */}
          </div>
        </div>
        <div className="cash-account-profile-box">
          <div className="cash-account-main">
            <div className="cash-account-main-item">
              <div className={classnames(accessibility.fontSizeMagnification > 1 ?'cash-account-main-item-title-accessibility' :'cash-account-main-item-title')}>
                {getSafe(() => language.current_account_net_assets)} ({getSafe(() => asset.currencyID, '--')})
              </div>
              <div className='cash-account-main-item-data' style={{fontSize:'1.84em',fontWeight:"bolder"}}>
                {utilsFunction.formatNumber(asset.ledgerBalance, 2)}
              </div>
            </div>
            <div className="cash-account-main-item">
              <div className={classnames(accessibility.fontSizeMagnification > 1 ?'cash-account-main-item-title-accessibility' :'cash-account-main-item-title')}>
               {getSafe(() => language.current_account_today_PL)}
              </div>
              <div className='cash-account-main-item-data' style={Converter.colorMapping(
                  colorTypes.UP_DOWN,
                  getSafe(() => asset.todayDelayedProfitAndLoss.replaceAll(settingConfigs.PRICE.thousandSeparator, ''), 0)
                )}>
                {asset.todayDelayedProfitAndLoss ? formatFunctions.dataFormat(asset.todayDelayedProfitAndLoss, dataType.CASH) : '-'} (-)
              </div>
            </div>
            <div className="cash-account-main-item">
              <div className={classnames(accessibility.fontSizeMagnification >1 ?'cash-account-main-item-title-accessibility' :'cash-account-main-item-title')}>
                {getSafe(() => language.current_account_position_PL)}
              </div>
              <div className='cash-account-main-item-data'
                style={Converter.colorMapping(
                  colorTypes.UP_DOWN,
                  getSafe(() => portfolio.floatingPL.replaceAll(settingConfigs.PRICE.thousandSeparator, ''), 0)
                )}>
                  <span>{portfolio.floatingPL ?
                    (Number(portfolio.floatingPL) > 0 ? `+${portfolio.floatingPL}` : (Number(portfolio.floatingPL) === 0 ? `${portfolio.floatingPL}` : `${portfolio.floatingPL}`)) :
                    '-'}</span>
                  <span> ({portfolio.floatingPLPercent ?
                    (Number(portfolio.floatingPLPercent) > 0 ? `+${portfolio.floatingPLPercent}` : (Number(portfolio.floatingPLPercent) === 0 ? `${portfolio.floatingPLPercent}` : `${portfolio.floatingPLPercent}`)) :
                    `-`})</span>
              </div>
            </div>
          </div>
          <div className="cash-account-details">
            <div className="cash-account-details-left">
              {TTLLeftAsset && TTLLeftAsset.map(item => 
                <div className={classnames(accessibility.fontSizeMagnification >1 ?'cash-account-details-item-accessibility' :'cash-account-details-item')} key={item.label}>
                  <div>{getSafe(() => language[item.label])}</div>
                  <div style={{ color: item.textColor ? item.textColor : '', marginRight: '30px' }}>
                    {item.value}
                  </div>
                </div>
              )}
            </div>
            <div className="cash-account-details-right">
              {TTLRightAsset && TTLRightAsset.map(item => 
                <div className={classnames(accessibility.fontSizeMagnification >1 ?'cash-account-details-item-accessibility' :'cash-account-details-item')} key={item.label}>
                  <div>{getSafe(() => language[item.label])}</div>
                  <div>{item.value}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  getAccountBalance = () => {
    const { user, currentTradingAccount, language, tradingAccount } = this.props;
    const { clientID } = currentTradingAccount
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang
      // [requestParams.TRADING_ACC_SEQ]: tradingAccSeq,
      // [requestParams.MARKET_ID]: ,
      // [requestParams.CURRENCY_ID]: ,
      // [requestParams.SHOW_DETAILS]: 'Y'
    }
    this.setState({
      isLoading: true
    })
    this.props.getAccountBalance(params, res => {
      this.setState({
        isLoading: false
      })
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          asset: res.result,
          TTLLeftAsset: Converter.mapAccountAsset(res.result).TTLLeftAsset,
          TTLRightAsset: Converter.mapAccountAsset(res.result).TTLRightAsset,
        })
      }
    })
    this.props.getPortfolioAction(params, res => {
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          portfolio: res,
        })
      }
    })
  }

  accountType = (val) => {
    switch (val) {
      case ACCOUNT_TYPE.CASH: {
        return this.props.language.common_cash_account
      }
      case ACCOUNT_TYPE.MARGIN: {
        return this.props.language.common_margin_account
      }
    }
  }

  bindingColor(value) {
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }

  componentDidMount() {
    this.getAccountBalance()
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getAccountBalance()
    }
    if (this.props.portfolios !== preProps.portfolios) {
      this.setState({
        portfolio: Converter.mapAccountPL(this.props.portfolios)
      })
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    tradingAccount: state.auth.tradingAccount,
    currentTradingAccount: state.trade.currentTradingAccount,
    portfolios: state.trade.portfolios,
    accessibility: state.app.accessibility
  }),
  dispatch => ({
    getAccountBalance: (p, c) => dispatch(getAccountBalanceAction(p, c)),
    getPortfolioAction: (p, c) => dispatch(getPortfolioAction(p, c))
  })
)(CashAccountProfile)